import {
  Component,
  computed,
  effect,
  inject,
  signal,
  untracked,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Router } from "@angular/router";
import { TranslocoModule } from "@jsverse/transloco";
import { JourneyBreadcrumb } from "src/app/features/pages/journey-result-pages/common/journey-breadcrumb/journey-breadcrumb";
import { Icon } from "src/app/shared/components/utils/icon/icon";
import { Loader } from "src/app/shared/components/loader/loader";
import { ContactCard } from "src/app/shared/components/contact-card/contact-card";
import { JourneySearchStore } from "src/app/features/store/journey-search-store";
import { LanguageFilter } from "src/app/shared/components/language-filter/language-filter";
import { MobilityContactCardInterface } from "src/app/core/interfaces/mobility-contact-card-interface";
import { ProgressionBar } from "src/app/features/pages/journey-result-pages/common/progression-bar/progression-bar";
import { Button } from "src/app/shared/components/utils/button/button";
import { LanguageService } from "src/app/core/services/language-service";

@Component({
  selector: "app-mobility-ref-page",
  imports: [
    TranslocoModule,
    JourneyBreadcrumb,
    Icon,
    Loader,
    ContactCard,
    LanguageFilter,
    ProgressionBar,
    Button,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./mobility-ref-page.html",
})
export class MobilityRefPage {
  private readonly languageService = inject(LanguageService);

  store = inject(JourneySearchStore);
  router = inject(Router);
  allMobilityRefs = computed(() => this.store.mobilityRefs());
  mobilityRefsLoading = computed(() => this.store.mobilityRefsLoading());

  mobilityRefstoDisplay = signal<MobilityContactCardInterface[]>([]);

  availableLanguages = signal<string[]>([]);

  constructor() {
    effect(() => {
      this.languageService.currentLanguage();

      untracked(async () => {
        this.availableLanguages.set([]);
        await this.store.loadJourneyFilters();
        await this.store.loadMobilityRefs();
        for (const contact of this.allMobilityRefs()) {
          this.addContactLanguagesToAvailable(contact);
        }
        this.mobilityRefstoDisplay.set(this.allMobilityRefs().slice(0, 3));
      });
    });
  }

  private addContactLanguagesToAvailable(
    contact: MobilityContactCardInterface
  ): void {
    (contact.languages ?? []).forEach((lang) => {
      if (!this.availableLanguages().includes(lang)) {
        const updatedLanguages = [...this.availableLanguages(), lang];
        this.availableLanguages.set(
          updatedLanguages.sort((a, b) => a.localeCompare(b))
        );
      }
    });
  }

  redirectToJourneyResearch(): void {
    this.router.navigate(["/journey/search"]);
  }

  updateResults(selectedLanguages: string[]): void {
    if (selectedLanguages.length === 0) {
      this.mobilityRefstoDisplay.set(this.allMobilityRefs().slice(0, 3));
    } else {
      const filteredRefs = this.allMobilityRefs().filter((ref) =>
        selectedLanguages.every((lang) => (ref.languages ?? []).includes(lang))
      );
      this.mobilityRefstoDisplay.set(filteredRefs.slice(0, 3));
    }
  }
}
